<div
    class="x-dropdown-base__form-control c-form-control d-flex align-items-center flex-wrap"
    [class.is-disabled]="disabled"
    [class.x-dropdown-base__form-control--multi]="
        dropdownType === DropdownType.MULTIPLE && selectedCount
    "
    [class.x-dropdown-base__form-control--split]="
        dropdownType === DropdownType.SPLIT_DROPDOWN
    "
    [class.is-clickable]="
        dropdownType === DropdownType.DROPDOWN ||
        dropdownType === DropdownType.SPLIT_DROPDOWN ||
        (dropdownType === DropdownType.MULTIPLE && !isShowingPopover)
    "
    [class.is-focus]="isFocused"
>
    <ng-container *ngIf="dropdownType === DropdownType.MULTIPLE">
        <ng-content select="[selectedChips]"></ng-content>
    </ng-container>

    <input
        type="text"
        class="c-dropdown-base__text-field"
        #searchInputField
        *ngIf="
            dropdownType === DropdownType.SINGLE ||
            dropdownType === DropdownType.MULTIPLE
        "
        [class.hidden]="isInputHidden"
        [value]="(dropdownType === DropdownType.SINGLE && displayValue) || ''"
        tabindex="-1"
        placeholder="{{ !selectedCount ? (placeholder | translate) : '' }}"
    />
    <div
        *ngIf="dropdownType === DropdownType.DROPDOWN"
        class="c-dropdown-base__dropdown-wrapper"
        #dropdownWrapper
    >
        <ng-container *ngIf="searchInput; else emptyBlock">
            <span class="{{ selectionClass }}">{{
                displayValue | translate
            }}</span>
        </ng-container>
        <ng-template #emptyBlock>
            <span
                *ngIf="placeholder; else blank"
                class="c-dropdown-base__dropdown-placeholder"
            >
                {{ placeholder | translate }}
            </span>
            <ng-template #blank> &nbsp; </ng-template>
        </ng-template>
        <ihd-icon
            name="alt-arrow-up"
            class="c-icon--xs x-dropdown-base__icon--up"
        ></ihd-icon>
        <ihd-icon
            name="alt-arrow-down"
            class="c-icon--xs x-dropdown-base__icon--down"
            [class.c-icon--secondary]="isShowingPopover"
        ></ihd-icon>
    </div>
    <ng-container *ngIf="dropdownType === DropdownType.SPLIT_DROPDOWN">
        <div class="l-row l-row--no-gutters w-100">
            <div class="l-col-auto">
                <span class="c-dropdown-base__label">{{
                    label | translate
                }}</span>
            </div>
            <div class="l-col-auto">
                <div class="c-dropdown-base__separator"></div>
            </div>
            <div class="l-col">
                <div
                    class="c-dropdown-base__dropdown-wrapper mr-3"
                    #dropdownWrapper
                >
                    <ng-container *ngIf="searchInput; else emptyBlock">
                        <span class="{{ selectionClass }}">{{
                            displayValue | translate
                        }}</span>
                    </ng-container>
                    <ng-template #emptyBlock>
                        <span
                            *ngIf="placeholder; else blank"
                            class="c-dropdown-base__dropdown-placeholder"
                        >
                            {{ placeholder | translate }}
                        </span>
                        <ng-template #blank> &nbsp; </ng-template>
                    </ng-template>
                    <ihd-icon
                        name="alt-arrow-down"
                        class="c-icon--xs x-dropdown-base__split-icon--down"
                        [class.c-icon--secondary]="isShowingPopover"
                    ></ihd-icon>
                </div>
            </div>
        </div>
    </ng-container>
</div>
<ihd-pop
    class="c-pop--compact"
    [(show)]="isShowingPopover"
    (onClose)="onPopoverClose($event)"
    alignment="left"
    [width]="popoverWidth"
>
    <div #header [class.c-dropdown-base__header]="header.childNodes.length">
        <ng-content select="[header]"></ng-content>
    </div>
    <div class="c-dropdown-base__list" #optionsListPanel>
        <ng-content></ng-content>
    </div>
    <div #footer [class.c-dropdown-base__footer]="footer.childNodes.length">
        <ng-content select="[footer]"></ng-content>
    </div>
</ihd-pop>
